module.exports = __webpack_public_path__ + "img/audio.8ca14ebd.png";